import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { LabStatusType } from '@/types/labs';

type LabMeta = {
    labType: string;
    name: string;
    introduction: string | null;
};

type LabResource = {
    labAvatarResourceUrl: string;
    labAvatarUuid: string;
    labAvatarExtension: string;
    labHeaderResourceUrl: string;
    labHeaderUuid: string;
    labHeaderExtension: string;
};

type LabMember = {
    schoomyersId: string | null;
};

type LabManageStore = {
    isLabMetaCompleted: boolean;
    isLabResourceCompleted: boolean;
    isLabMemberCompleted: boolean;
    editLabId: number | null;
    labStatus: LabStatusType;
    registeredLabMeta: LabMeta | null;
    registeredLabResource: LabResource | null;
    registeredLabMember: LabMember | null;
    setIsLabMetaCompleted: (isLabMetaCompleted: boolean) => void;
    setIsLabResourceCompleted: (isLabDesignCompleted: boolean) => void;
    setIsLabMemberCompleted: (isLabMemberCompleted: boolean) => void;
    setEditLabId: (labId: number | null) => void;
    setLabStatus: (labStatus: LabStatusType) => void;
    setRegisteredLabMeta: (registeredLabMeta: LabMeta | null) => void;
    setRegisteredLabResource: (registeredLabResource: LabResource | null) => void;
    setRegisteredLabMember: (registeredLabMember: LabMember | null) => void;
    reset: () => void;
};

export const useLabManageStore = create<LabManageStore>()(
    persist(
        (set) => ({
            isLabMetaCompleted: false,
            isLabResourceCompleted: false,
            isLabMemberCompleted: false,
            editLabId: null,
            labStatus: 'draft',
            registeredLabMeta: null,
            registeredLabResource: null,
            registeredLabMember: null,
            setIsLabMetaCompleted: (flag) => set({ isLabMetaCompleted: flag }),
            setIsLabResourceCompleted: (flag) => set({ isLabResourceCompleted: flag }),
            setIsLabMemberCompleted: (flag) => set({ isLabMemberCompleted: flag }),
            setEditLabId: (value) => set({ editLabId: value }),
            setLabStatus: (status) => set({ labStatus: status }),
            setRegisteredLabMeta: (value) => set({ registeredLabMeta: value }),
            setRegisteredLabResource: (value) => set({ registeredLabResource: value }),
            setRegisteredLabMember: (value) => set({ registeredLabMember: value }),
            reset: () =>
                set({
                    editLabId: null,
                    labStatus: 'draft',
                    isLabMetaCompleted: false,
                    isLabResourceCompleted: false,
                    isLabMemberCompleted: false,
                    registeredLabMeta: null,
                    registeredLabResource: null,
                    registeredLabMember: null,
                }),
        }),
        {
            name: 'KEY-LAB-MANAGE-DATA',
            storage: typeof window !== 'undefined' ? createJSONStorage(() => localStorage) : undefined,
        },
    ),
);
